import { gtmDataLayer, gtmCustomDataLayer } from "../../utils/gtm";

export const formSubmissionError = () => gtmDataLayer("formSubmissionError");

export const tourSubmission = () => gtmDataLayer("tourSubmission");

export const submissionBigTeam = () => gtmDataLayer("submissionBigTeam");

export const formSubmissionSuccess = () =>
  gtmDataLayer("formSubmissionSuccess");

export const formContactSubmission = () =>
  gtmDataLayer("formContactSubmission");

export const formNewsletterSubmission = () =>
  gtmDataLayer("formSubmissionSuccess_Newsletter");

export const resourceFormSubmission = () =>
  gtmDataLayer("resourceFormSubmission");

export const selectedLocationInForm = (value) =>
  gtmCustomDataLayer("selectedLocationInForm", value);

export const bookATourPartnerize = () => gtmDataLayer("bookATourPartnerize");

export const applicationPartnerize = (id) => {
  dataLayer.push({
    event: "applicationPartnerize",
    uniqueTimeStamp: id,
  });
};
